import { FundingSource } from '@melio/platform-api';
import { forwardRef } from '@melio/platform-utils';

import { AddFundingSourceScreen } from './screens';

export type AddFundingSourceActivityProps = {
  onBack?: VoidFunction;
  onDone: (type: FundingSource['type']) => unknown;
  onClose?: VoidFunction;
  billId?: string;
};

export const AddFundingSourceActivity = forwardRef<AddFundingSourceActivityProps>(
  ({ onDone, onBack, billId, ...props }, ref) => (
    <AddFundingSourceScreen billId={billId} onSelect={(type) => onDone(type)} onBack={onBack} {...props} ref={ref} />
  )
);
AddFundingSourceActivity.displayName = 'AddFundingSourceActivity';
